import { useMemo } from 'react';
import useCompanyPhase from '../company-details/hooks/use-company-phase';
import { SivaPhase } from 'src/api/v2';

// This is placed here as readonly array to keep a stable reference
// (makes unnecessary rerenders easier to avoid)
const withoutCompanyOptions: ReadonlyArray<SivaPhase> = [SivaPhase.Idea, SivaPhase.PreIncubation];

export function useAvailablePhases(organizationNumber: string | undefined): {
  availablePhases: ReadonlyArray<SivaPhase>;
  isLoading: boolean;
} {
  const { companyAvailablePhases } = useCompanyPhase(organizationNumber);

  const availablePhases = useMemo(() => {
    if (!organizationNumber) return withoutCompanyOptions;
    return companyAvailablePhases.data ?? [];
  }, [organizationNumber, companyAvailablePhases.data]);

  return {
    availablePhases,
    isLoading: companyAvailablePhases.isInitialLoading,
  };
}
